module.exports = __webpack_public_path__ + "static/media/b-sci-major-38_LR.c024e2fb.jpg";